<script>
export default {
  name: 'ImageModal',
  components: {},
  props: {
    image: {
      type: String,
      required: true,
    },
  },
}
</script>

<template>
  <div :class="$style.imgWrapper">
    <img
      :class="$style.image"
      :src="image"
    >

  </div>
</template>

<style lang="scss" scoped module>
@import '@design';

.image {
  min-width: 6rem;
  max-width: 100%;
  min-height: 6rem;
  max-height: 100%;
  border-radius: 10px;
}

.imgWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 20rem;
}
</style>
